const ShimmerTopCategories = ({ count = 4 }) => {
  return (
    <section className="mt-10 px-4 sm:px-6 animate-pulse">
      
      {/* Header */}
      <div className="mb-4">
        <div className="h-6 w-48 bg-slate-200 rounded mb-2"></div>
        <div className="h-4 w-64 bg-slate-200 rounded"></div>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(count)].map((_, i) => (
          <div
            key={i}
            className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-100"
          >
            {/* Image */}
            <div className="h-36 w-full bg-slate-200"></div>

            {/* Content */}
            <div className="p-4 space-y-2">
              <div className="h-4 w-3/4 bg-slate-200 rounded"></div>
              <div className="h-3 w-1/2 bg-slate-200 rounded"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ShimmerTopCategories;